/* eslint-disable react/prop-types */
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  Button,
  Divider,
  FormLabel,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';

import { createTheme, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { postApiCall } from 'api/apiService';
import {
  ADD_PROPERTY_LEGAL,
  SOLICITOR_CHECK_IN,
  ADD_PROPERTY_MEDIA,
} from 'constant/app.config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { pdfjs } from 'react-pdf';
import { toast } from 'react-toastify';
import { poppins500 } from 'theme/common.style';
import DeleteIcon from '../../assets/images/DeleteIcon.png';
import PdfIcon from '../../assets/images/pdficon.png';
import { handleKeyDown } from './AddListingModal';
import { AirbnbSlider, AirbnbThumbComponent } from './CustomizedSlider';
import {
  checkbox_style,
  pick_date,
  textboxmargin,
  textboxmargin_description,
  typography_textfield,
} from './PropertyCreation.style';
import Loading from 'assets/images/loading.png';
import PropertyAddressField from './PropertyAddressField';
// Set up pdfjs worker
import 'pdfjs-dist/webpack.mjs';

dayjs.extend(utc);
dayjs.extend(timezone);
const todayInSydney = dayjs().tz('Australia/Sydney');

function formatNumber(num, showFull = false) {
  const formatter = new Intl.NumberFormat('en-US');
  if (num >= 0 && num < 10) {
    return `$${parseFloat(num.toFixed(1))}`;
  }
  if (num >= 1000000) {
    return `$${parseFloat((num / 1000000).toFixed(1))}M`;
  }
  if (num >= 1000) {
    return showFull
      ? `$${formatter.format(num)}`
      : `$${parseFloat((num / 1000).toFixed(1))}K`;
  }
  return `$${formatter.format(num)}`;
}

function valueLabelFormat(slidervalue, showFull = false) {
  return formatNumber(slidervalue, showFull);
}

const FlexBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));
const DropZone = styled(FlexBox)(({ isDragActive, theme }) => ({
  width: '100%',
  height: 160,
  cursor: 'pointer',
  marginBottom: '16px',
  borderRadius: '4px',
  justifyContent: 'center',
  transition: 'all 350ms ease-in-out',
  border: '2px dashed rgba(108, 42, 210, 1)',
  background: isDragActive ? 'rgb(0, 0, 0, 0.15)' : '#f0e9fa',
}));
export default function LegalDetailsAdd({
  value,
  setValue,
  onClose,
  options,
  agencyTrueEstimatePrice,
  setAgencyTrueEstimatePrice,
  fromHeader,
  resumeTempId,
  dashboardcount,
  setLegalSliderRange,
  pipelineTempId,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [firstNameval, setFirstNameval] = useState('');
  const [lastNameval, setLastNameval] = useState('');
  const [mobileval, setMobileval] = useState('');
  const [emailval, setEmailval] = useState('');

  const [contractsale, setContractsale] = useState('');
  const [media, setMedia] = useState([]);
  const [unitNumber, setUnitNumber] = useState('');
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [selectedStreetType, setSelectedStreetType] = useState('');
  const [selectedStreetTypeformat, setSelectedStreetTypeformat] = useState({
    label: '',
    type: 'option',
  });
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [email, setEmail] = useState('');
  const [contractMedia, setContractMedia] = useState([]);
  const [selectedSolicitorAddress, setSelectedSolicitorAddress] = useState('');

  const [errorMessageContractMedia, setErrorMessageContractMedia] =
    useState('');
  const [errorMessage, setErrorMessage] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageLastName, setErrorMessageLastName] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageNumber, setErrorMessageNumber] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageAddress, setErrorMessageAddress] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageEmail, setErrorMessageEmail] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageContract, setErrorMessageContract] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageAgencyAgreement, setErrorMessageAgencyAgreement] =
    useState({ helperText: '', error: false });
  const [errorMessageAgreedMarketing, setErrorMessageAgreedMarketing] =
    useState({ helperText: '', error: false });
  const [errorMessageAgreedCommission, setErrorMessageAgreedCommission] =
    useState({ helperText: '', error: false });
  const [dateOfAgreement, setDateOfAgreement] = useState(null);
  const [errorMessageDateOfAgreement, setErrorMessageDateOfAgreement] =
    useState('');
  const [pdfValidation, setPdfValidation] = useState(false);
  const [contractValidation, setContractValidation] = useState(false);
  const [addAddress, setAddAddress] = useState(false);
  const [recentlyClosed, setRecentlyClosed] = useState(false);

  const [selectedState, setSelectedState] = useState('');
  const [postCode, setPostCode] = useState('');
  const [town, setTown] = useState('');
  const [commissionFee, setCommissionFee] = useState('');
  const [agreedMarketingBudget, setAgreedMarketingBudget] = useState('');
  const [slidervalue, setSlidervalue] = React.useState([600000, 2600000]);
  const [streetNumber, setStreetNumber] = useState('');
  const [streetName, setStreetName] = useState('');
  const [includesGST, setIncludesGST] = useState(true);
  const theme = useTheme();
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches1200 = useMediaQuery(theme.breakpoints.down(1200));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const firstnameref = useRef(null);
  const lastnameref = useRef(null);
  const emailref = useRef(null);
  const mobileref = useRef(null);
  const addressref = useRef(null);
  const agencyagreementref = useRef(null);
  const dateofagreementref = useRef(null);
  const commissionFeeref = useRef(null);
  const marketingbudgetref = useRef(null);
  const estimatepriceref = useRef(null);
  const vendornameref = useRef(null);
  const contractdocref = useRef(null);
  const ignoreNextFocus = useRef(false);

  useEffect(() => {
    setSlidervalue([600000, 2600000]);
  }, []);

  const [userSelected, setUserSelected] = useState(false);

  const [foundData, setFoundData] = useState(false);
  const [checkInData, setCheckInData] = useState();
  const [checkInErrorData, setCheckInErrorData] = useState();
  const [checkInIndex, setCheckInIndex] = useState();

  const emailInputRef = useRef(null);
  // for suggestions placement
  const [firstNameAnchor, setFirstNameAnchor] = useState(false);
  const [lastNameAnchor, setLastNameAnchor] = useState(false);
  const [mobileAnchor, setMobileAnchor] = useState(false);
  const [emailAnchor, setEmailAnchor] = useState(false);
  const closeAllAnchors = () => {
    setFirstNameAnchor(false);
    setLastNameAnchor(false);
    setMobileAnchor(false);
    setEmailAnchor(false);
  };

  const solicitorCheckin = (data) => {
    if (!data || data.length === 0) return; // ⛔ stop API trigger when deleting

    const inputData = {
      contactValue: data,
    };

    setFoundData(true);

    postApiCall(SOLICITOR_CHECK_IN, inputData).then(async (res) => {
      if (res?.data?.status == 1) {
        setCheckInData(res?.data);
        setFoundData(false);
        setCheckInErrorData('');
      } else {
        setCheckInErrorData(res?.data);
        setFoundData(false);
      }
    });
  };

  const [pdfErrorOpen, setPdfErrorOpen] = useState(false);
  const [pdfErrorFile, setPdfErrorFile] = useState('');
  const [pdfErrorOpen1, setPdfErrorOpen1] = useState(false);
  const [pdfErrorFile1, setPdfErrorFile1] = useState('');
  const MAX_FILE_SIZE = 15 * 1024 * 1024;
  const MAX_FILE_COUNT = 3;
  const closeFunction = () => {
    setPdfErrorOpen(false);
    setPdfErrorFile('');
    setPdfErrorOpen1(false);
    setPdfErrorFile1('');
  };

  const [errorMessageAgencyMedia, setErrorMessageAgencyMedia] = useState({
    helperText: '',
    error: false,
    duplicateNames: null,
  });

  const onDropCallback = useCallback(
    (acceptedFiles) => {
      const updatedMedia = [...media]; // Work with the latest media files

      // Check for duplicate files
      const duplicateFileNames = acceptedFiles.filter((file) =>
        updatedMedia.some((existingFile) => existingFile.name === file.name)
      );

      if (duplicateFileNames.length > 0) {
        const duplicateFileNamesSet = new Set(
          duplicateFileNames.map((file) => file.name)
        );
        setErrorMessageAgencyMedia({
          helperText: `You cannot upload files with the same names: ${[
            ...duplicateFileNamesSet,
          ].join(', ')}`,
          error: true,
          duplicateNames: duplicateFileNamesSet,
        });
        return;
      }

      // Check if the total number of files exceeds the limit
      if (updatedMedia.length + acceptedFiles.length > 3) {
        setErrorMessageAgencyMedia({
          helperText: 'You can upload up to three files only.',
          error: true,
          duplicateNames: null,
        });
        return;
      }

      // Process files and ensure state updates are controlled
      const processFilePromises = acceptedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          if (file.size > MAX_FILE_SIZE) {
            // Handle file size validation
            setPdfErrorOpen(true);
            setPdfErrorFile(file.name);
            reject(new Error('File size exceeds the limit'));
          } else {
            const reader = new FileReader();
            reader.onload = (e) => {
              const typedArray = new Uint8Array(e.target.result);

              // Validate the PDF content
              pdfjs
                .getDocument({
                  data: typedArray,
                  isEvalSupported: false,
                })
                .promise.then(() => {
                  resolve(file); // File is valid
                })
                .catch(() => {
                  reject(new Error('Error processing the file'));
                });
            };

            reader.readAsArrayBuffer(file);
          }
        });
      });

      Promise.allSettled(processFilePromises).then((results) => {
        const validFiles = results
          .filter((result) => result.status === 'fulfilled')
          .map((result) => result.value);

        if (validFiles.length + updatedMedia.length <= 3) {
          setMedia((prevFiles) => [...prevFiles, ...validFiles]);
          setErrorMessageAgencyMedia({
            helperText: '',
            error: false,
            duplicateNames: null,
          });
        } else {
          setErrorMessageAgencyMedia({
            helperText: 'Adding these files exceeds the upload limit of 3 PDFs',
            error: true,
          });
        }

        // Clear the file input value after processing
        if (agencyagreementref.current) {
          agencyagreementref.current.value = '';
        }
      });
    },
    [media, setMedia]
  );

  const validateEmail = (inputEmail) => {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const isValid = emailPattern.test(inputEmail);
    setIsValidEmail(isValid);
    return;
  };

  const handleEmailChange = (event) => {
    const inputEmail = event.target.value;
    validateEmail(inputEmail);
    // setIsValidEmail(isValid);
    setEmail(inputEmail);
  };
  const handleKeyPress = (event) => {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  };

  const [acceptedFiles, setAcceptedFiles] = useState([]);

  const onDrop = useCallback(
    (newFiles) => {
      setMedia((prevFiles) => [...prevFiles, ...newFiles]);
    },
    [setMedia]
  );
  // Format the number with commas
  const formattedAgreedMarketingBudget = agreedMarketingBudget.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ','
  );
  const formatPrice = (price) => {
    return (price || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // const formattedAgencyTrueEstimatePrice = formatPrice(agencyTrueEstimatePrice);
  const handleAgreedMarketingBudgetChange = (event) => {
    const input = event.target;
    const selectionStart = input.selectionStart;
    const oldValue = input.value;

    setErrorMessageAgreedMarketing({
      helperText: '',
      error: false,
    });

    let newValue = oldValue ?? '';

    if (typeof newValue === 'string') {
      // Clean and limit digits
      let rawDigits = newValue.replace(/\D/g, '').slice(0, 6);
      if (rawDigits.length > 1) {
        rawDigits = rawDigits.replace(/^0+/, '');
      }
      if (rawDigits === '' && newValue.startsWith('0')) {
        rawDigits = '0';
      }
      setAgreedMarketingBudget(rawDigits);

      // Cursor position fix
      requestAnimationFrame(() => {
        if (
          input &&
          typeof input.setSelectionRange === 'function' &&
          document.activeElement === input
        ) {
          const digitsBeforeCursor = oldValue
            .slice(0, selectionStart)
            .replace(/\D/g, '').length;
          const formattedValue =
            rawDigits === '' ? '' : Number(rawDigits).toLocaleString('en-US');

          let cursorPos = 0;
          let digitCount = 0;

          for (let i = 0; i < formattedValue.length; i++) {
            if (/\d/.test(formattedValue[i])) {
              digitCount++;
            }
            if (digitCount === digitsBeforeCursor) {
              cursorPos = i + 1;
              break;
            }
          }

          if (digitCount < digitsBeforeCursor) {
            cursorPos = formattedValue.length;
          }

          input.setSelectionRange(cursorPos, cursorPos);
        }
      });
    }
  };

  const handleKey = (event) => {
    // Prevent 'e' character from being entered
    if (event.key === 'e') {
      event.preventDefault();
    }
  };

  const handleAgencyTrueEstimatePriceChange = (newValue) => {
    setAgencyTrueEstimatePrice(newValue);
    if (newValue !== '') {
      let tenPercent = parseInt(newValue) * 0.1;
      setSlidervalue([
        parseInt(newValue) - 0.1 * parseInt(newValue),
        parseInt(newValue) + parseInt(tenPercent),
      ]);
    } else {
      // Handle default slider values when input is empty
      setSlidervalue([2000000, parseInt(slidervalue[1])]);
    }
  };
  const [maxSliderValue, setMaxSliderValue] = useState(6000000);
  const [minSliderValue, setMinSliderValue] = React.useState(0);

  const CustomValueLabel = ({ value }) => {
    return (
      <div>{value < 1000000 ? value : `${Math.floor(value / 1000000)}M`}</div>
    );
  };

  const [
    formattedAgencyTrueEstimatePrice,
    setFormattedAgencyTrueEstimatePrice,
  ] = useState('');

  const handleTextFieldChange = (event) => {
    const input = event.target;
    const selectionStart = input.selectionStart;
    const oldValue = input.value;

    // Extract digits
    let inputValue = oldValue.replace(/\D/g, '');

    if (inputValue) {
      const numericValue = parseInt(inputValue, 10);
      const newMin = numericValue;
      const newMax = Math.round(numericValue + numericValue * 0.1);

      setAgencyTrueEstimatePrice(inputValue);
      setSlidervalue([newMin, newMax]);
      setLegalSliderRange([newMin, newMax]);
      setMinSliderValue(Math.max(0, newMin - Math.round(newMin * 0.1)));
      setMaxSliderValue(Math.max(newMax, newMax + Math.round(newMax * 0.1)));

      // Update formatted value
      setFormattedAgencyTrueEstimatePrice(
        Number(inputValue).toLocaleString('en-US')
      );

      // ✅ Clear error as soon as user types
      setErrorMessageAgencyAgreement({ helperText: '', error: false });
    } else {
      setSlidervalue([600000, 2600000]);
      setLegalSliderRange([600000, 2600000]);
      setMaxSliderValue(6000000);
      setAgencyTrueEstimatePrice('');
      setFormattedAgencyTrueEstimatePrice('');

      // Optional: show error only if field is empty
      // setErrorMessageAgencyAgreement({ helperText: 'Enter the True Estimate minimum value', error: true });
    }

    // Cursor fix logic
    requestAnimationFrame(() => {
      if (
        input &&
        typeof input.setSelectionRange === 'function' &&
        document.activeElement === input
      ) {
        const digitsBeforeCursor = oldValue
          .slice(0, selectionStart)
          .replace(/\D/g, '').length;
        const formattedValue =
          inputValue === '' ? '' : Number(inputValue).toLocaleString('en-US');

        let cursorPos = 0;
        let digitCount = 0;

        for (let i = 0; i < formattedValue.length; i++) {
          if (/\d/.test(formattedValue[i])) {
            digitCount++;
          }
          if (digitCount === digitsBeforeCursor) {
            cursorPos = i + 1;
            break;
          }
        }

        if (digitCount < digitsBeforeCursor) {
          cursorPos = formattedValue.length;
        }

        input.setSelectionRange(cursorPos, cursorPos);
      }
    });
  };

  const handleSliderChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) return;
    if (activeThumb === 0) {
      const updatedRange = [
        newValue[0],
        Math.round(newValue[0] + newValue[0] * 0.1),
      ];
      setSlidervalue(updatedRange);
      setLegalSliderRange(updatedRange);
      // setSlidervalue([
      //   newValue[0],
      //   Math.round(newValue[0] + newValue[0] * 0.1),
      // ]);
    } else {
      const updatedRange = [
        Math.round(newValue[1] - newValue[1] * 0.1),
        newValue[1],
      ];
      setSlidervalue(updatedRange);
      setLegalSliderRange(updatedRange);
      // setSlidervalue([
      //   Math.round(newValue[1] - newValue[1] * 0.1),
      //   newValue[1],
      // ]);
    }

    setAgencyTrueEstimatePrice(newValue[0]);
  };

  function ensureMinimumLength(minLength, value) {
    let leadingZeros = '1';

    if (String(minLength) == '7') {
      if (parseInt(value) > 900000 && parseInt(value) < 3000000) {
        leadingZeros = '3000000';
      } else {
        leadingZeros = '6000000';
      }

      setMaxSliderValue(leadingZeros);

      return leadingZeros;
    } else {
      for (let i = 0; i < Number(minLength); i++) {
        leadingZeros = String(leadingZeros) + '0';
      }
      if (parseInt(value) > 6000000) {
        setMaxSliderValue(String(value) + '0');
      } else {
        setMaxSliderValue(leadingZeros);
      }

      return leadingZeros;
    }

    // Check if the length of the string is less than the minimum length
  }
  // Update agencyTrueEstimatePrice when slider value changes

  function checkDifference(num1, num2) {
    const twentyPercent = Math.min(num1, num2) * 0.2;

    // Calculate the difference between the numbers
    const difference = Math.abs(num1 - num2);

    // If the difference is less than or equal to 20% of the smaller number, return true
    return difference <= twentyPercent;
  }
  const handleChange = (event, newValue) => {
    ensureMinimumLength(newValue[1].toString().length, newValue[1]);
    if (checkDifference(newValue[0], newValue[1])) {
      return;
    }
    // Adjust the increment based on the slider value
    if (slidervalue[0] == newValue[0] && slidervalue[1] != newValue[1]) {
      const increment = newValue[1] <= 2000000 ? 10000 : 50000;
      const roundedValue =
        newValue[1] <= 2000000
          ? Math.round(newValue[1] / increment) * increment
          : Math.min(6000000, newValue[1]);
      setSlidervalue([newValue[0], roundedValue]);
      // setSaleprice(newValue[0])
    } else {
      const increment = newValue[0] <= 2000000 ? 10000 : 50000;
      const roundedValue =
        newValue[0] <= 2000000
          ? Math.round(newValue[0] / increment) * increment
          : Math.min(6000000, newValue[0]);
      setSlidervalue([roundedValue, newValue[1]]);
      // setSaleprice(newValue[0])
    }
    // setAgencyTrueEstimatePrice(newValue[0]);
  };

  // const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
  //   onDrop,
  //   accept: { 'application/pdf': [], },
  //   multiple: true,
  // });

  const handleDelete = (fileName, event) => {
    event.stopPropagation();
    setMedia((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const onDropContractMedia = useCallback(
    (newFiles) => {
      setContractMedia((newFiles) => [...newFiles]);
    },
    [setContractMedia]
  );

  const ContractFunction = useCallback(
    (newFiles) => {
      const validFiles = newFiles.filter((file) => file.size <= MAX_FILE_SIZE);
      const invalidFiles = newFiles.filter((file) => file.size > MAX_FILE_SIZE);

      if (invalidFiles.length > 0) {
        setPdfErrorOpen1(true);
        setPdfErrorFile1(invalidFiles[0].name);
        return;
      }
      setContractMedia((prevMedia) => [...prevMedia, ...validFiles]);
      setContractValidation(false);
      setErrorMessageContractMedia('');
    },
    [setContractMedia]
  );

  const [errorMessages, setErrorMessages] = useState(''); // Use useState for error message state

  const handleButtonClickss = () => {
    // Reset the error message before validating the new file count
    setErrorMessages('');

    // Check if the total number of files exceeds the limit
    const totalFilesCount = media.length + acceptedFiles.length;
    if (totalFilesCount >= MAX_FILE_COUNT) {
      setErrorMessages('You can upload up to three files only.'); // Set error message if limit exceeded
      return;
    }

    // Trigger the file input click when the button is clicked
    if (agencyagreementref.current) {
      agencyagreementref.current.click();
    }
  };

  const {
    getRootProps: getContractProps,
    getInputProps: getContractInputProps,
    acceptedFile,
  } = useDropzone({
    onDrop: ContractFunction,
    accept: { 'application/pdf': [] },
    multiple: false,
    disabled: contractMedia.length > 0,
  });

  const { getRootProps, getInputProps, isDragAccept, isDragReject } =
    useDropzone({
      onDrop: onDropCallback,
      accept: { 'application/pdf': [] }, // Accept only PDF files
      multiple: true,
      disabled: media.length > 2,
    });

  const maxWords = 700;
  const marks = [];
  const maxAmount = 60000000;
  const increment = 50000;
  for (let value = 0; value <= maxAmount; value += increment) {
    marks.push({
      value: value,
      // label: `$${value.toLocaleString()}`,
    });
  }
  marks[marks.length - 1].value = maxAmount;

  const handleInputChange = (event) => {
    let text = event.target.value;

    // Regular expression to remove numbers
    // const sanitizedText = text.replace(/[0-9]/g, '');

    // Proceed with word count validation
    // const words = text.trim().split(/\s+/);
    // if (words.length <= maxWords) {

    const words = text?.trim().split(/\s+/);

    // If word count exceeds 40, ignore the change
    if (words?.length <= 40) {
      setContractsale(text);
    }

    text = text
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    // setContractsale(text);
    setErrorMessageContract({
      helperText: '',
      error: false,
    });
    // }
  };

  function addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    return date;
  }

  const handleCommissionFeeChange = (event) => {
    setErrorMessageAgreedCommission({
      helperText: '',
      error: false,
    });

    let newValue = event.target.value;

    // Remove non-numeric and non-decimal point characters
    newValue = newValue.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point is allowed
    const firstDotIndex = newValue.indexOf('.');
    if (firstDotIndex !== -1) {
      newValue =
        newValue.slice(0, firstDotIndex + 1) +
        newValue.slice(firstDotIndex + 1).replace(/\./g, '');
    }

    // Prevent leading zero unless it's like "0.xxx"
    if (newValue.length > 1 && newValue[0] === '0' && newValue[1] !== '.') {
      newValue = newValue.slice(1);
    }

    // Split into integer and decimal parts
    const parts = newValue.split('.');

    if (parts.length > 1) {
      let integerPart = parts[0];
      let decimalPart = parts[1];

      // ✅ Allow typing the dot with no decimals yet (e.g., "3.")
      if (decimalPart === '') {
        newValue = integerPart + '.';
      } else {
        // ✅ Limit decimal part to max 2 digits

        decimalPart = decimalPart.slice(0, 2);
        newValue = integerPart + '.' + decimalPart;

        // newValue = integerPart + (decimalPart ? '.' + decimalPart : '');
        // ❌ Block cases where decimal part is only zeros ("0.0", "0.00")
        // if (/^0+$/.test(decimalPart)) {
        //   decimalPart = '';
        // }

        // newValue = integerPart + (decimalPart ? '.' + decimalPart : '');
      }
    }

    // If no decimal and more than 4 digits, trim
    if (parts.length === 1 && parts[0].length > 4) {
      newValue = parts[0].slice(0, 4);
    }

    // Update state if valid
    if (newValue === '' || Number(newValue) <= 100) {
      setCommissionFee(newValue);
    }
  };

  const handleCommissionFeeBlur = () => {
    setCommissionFee((prev) => {
      if (prev && prev.endsWith('.')) {
        return prev.slice(0, -1); // remove trailing "."
      }
      return prev;
    });
  };

  // const handleMobileChange = (event) => {
  //   const inputValue = event.target.value.replace(/\D/g, ''); // Remove non-digit characters
  //   let formattedValue = inputValue;

  //   // Insert spaces at appropriate positions while typing
  //   formattedValue = formattedValue.replace(/^(\d{0,4})\s?(\d{0,3})\s?(\d{0,3})$/, '$1 $2 $3').trim();

  //   // Regular expression for the format "04XX XXX XXX"
  //   const mobileRegex = /^04\d{2}\s?\d{3}\s?\d{3}$/;

  //   // Check if the mobile number matches the format and has a length of 12 characters
  //   let error = '';
  //   if (!mobileRegex.test(formattedValue)) {
  //     error = 'Mobile number format should be: 04XX XXX XXX';
  //   }

  //   // Update the state with formatted value and error message
  //   setMobileval(formattedValue);
  //   setErrorMessageNumber({
  //     error: error !== '',
  //     helperText: error,
  //   });
  // };

  const validateAndFormatMobile = (value) => {
    const numericValue = value.replace(/\D/g, '');
    const formattedValue = numericValue
      .replace(/^(\d{0,4})(\d{0,3})(\d{0,3})$/, '$1 $2 $3')
      .trim();
    const mobileRegex = /^04\d{2}\s?\d{3}\s?\d{3}$/;
    const isValid = mobileRegex.test(formattedValue);
    setMobileval(formattedValue);
    setErrorMessageNumber({
      error: !isValid,
      helperText: !isValid
        ? 'Mobile number format should be: 04XX XXX XXX'
        : '',
    });
    return formattedValue;
  };

  const handleMobileChange = (event) => {
    const inputElement = event.target;
    const rawValue = inputElement.value;
    const cursorPosition = inputElement.selectionStart;

    // Save previous value to detect backspace
    const prevValue = mobileval || '';
    const isBackspace = prevValue.length > rawValue.length;

    // Count digits before cursor
    let digitsBeforeCursor = rawValue
      .slice(0, cursorPosition)
      .replace(/\D/g, '').length;

    // Adjust for backspace over space
    if (isBackspace && prevValue[cursorPosition - 1] === ' ') {
      digitsBeforeCursor -= 1;
    }

    // Format value: 04XX XXX XXX
    const formattedValue = validateAndFormatMobile(rawValue);

    // Restore cursor after render (smoothly, no jump)
    requestAnimationFrame(() => {
      const inputEl = document.getElementById('mobile-input');
      if (!inputEl) return;

      let actualCursor = 0;
      let digitCount = 0;

      while (
        digitCount < digitsBeforeCursor &&
        actualCursor < formattedValue.length
      ) {
        if (/\d/.test(formattedValue[actualCursor])) {
          digitCount++;
        }
        actualCursor++;
      }

      actualCursor = Math.min(actualCursor, formattedValue.length);
      inputEl.setSelectionRange(actualCursor, actualCursor);
    });
  };
  const formattedDate = moment(dateOfAgreement).format('YYYY-MM-DD');
  const roundToTens = (num) => Math.round(num / 10) * 10;
  const roundForApi = (value) => {
    if (value >= 100000000) {
      return Math.round(value / 100000) * 100000;
    } else if (value >= 10000000) {
      return Math.round(value / 10000) * 10000;
    } else if (value >= 1000000) {
      return Math.round(value / 10000) * 10000;
    } else if (value >= 10000) {
      return Math.round(value / 100) * 100;
    } else if (value >= 1000) {
      return Math.round(value / 10) * 10;
    } else if (value >= 100) {
      return Math.round(value);
    } else {
      return Math.round(value * 10) / 10;
    }
  };
  const legaldetails = () => {
    if (firstNameval === '' || !/^[a-zA-Z]/.test(firstNameval)) {
      setErrorMessage({
        helperText: 'Please enter first name',
        error: true,
      });
      firstnameref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (lastNameval === '' || !/^[a-zA-Z]/.test(lastNameval)) {
      setErrorMessageLastName({
        helperText: 'Please enter last name',
        error: true,
      });
      lastnameref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (!mobileval || !/^04\d{2}\s?\d{3}\s?\d{3}$/.test(mobileval)) {
      setErrorMessageNumber({
        helperText: 'Please enter mobile number',
        error: true,
      });
      setTimeout(() => {
        mobileref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      return;
    }
    if (!emailval && validateEmail(emailval)) {
      setErrorMessageEmail({
        helperText: 'Check your email address is valid',
        error: true,
      });
      setTimeout(() => {
        emailref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      return;
    }
    if (
      streetNumber == '' ||
      streetName == '' ||
      selectedStreetType == '' ||
      town == '' ||
      // postCode == ''
      postCode.length !== 4
    ) {
      setErrorMessageAddress({
        helperText: 'Please enter correct address',
        error: true,
      });
      addressref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageAddress({
        helperText: '',
        error: false,
      });
    }
    if (media.length < 1) {
      // setErrorMessageAgencyMedia('No agency agreement uploaded');
      setErrorMessageAgencyMedia({
        helperText: `No agency agreement uploaded`,
        error: true,
        duplicateNames: null,
      });
      setPdfValidation(true);
      agencyagreementref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }

    if (dateOfAgreement == null) {
      setErrorMessageDateOfAgreement(
        'Enter the date on which the Agency Agreement was executed'
      );
      dateofagreementref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    // Calculate the difference in milliseconds
    const differenceInTime =
      todayInSydney.toDate().getTime() -
      dayjs(dateOfAgreement).toDate().getTime();
    // Calculate the difference in days
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    if (differenceInDays > 180) {
      setErrorMessageDateOfAgreement(
        'Date of Agreement cannot be more than 180 days backdated.'
      );
      dateofagreementref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (dateOfAgreement >= todayInSydney.format('YYYY-MM-DD')) {
      setErrorMessageDateOfAgreement(
        'You cannot able to enter current / future date'
      );
      dateofagreementref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (commissionFee == '') {
      setTimeout(() => {
        if (commissionFeeref.current) {
          commissionFeeref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          });
        }
      }, 100);
      setErrorMessageAgreedCommission({
        helperText: 'Enter the agreed commission fee as a percentage',
        error: true,
      });
      return;
    }
    if (agreedMarketingBudget == '') {
      setTimeout(() => {
        if (marketingbudgetref.current) {
          marketingbudgetref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          });
        }
      }, 100);
      setErrorMessageAgreedMarketing({
        helperText: 'Enter the agreed marketing budget in dollars',
        error: true,
      });
      return;
    }
    if (agencyTrueEstimatePrice == '') {
      setTimeout(() => {
        if (estimatepriceref.current) {
          estimatepriceref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          });
        }
      }, 100);
      setErrorMessageAgencyAgreement({
        helperText:
          'Enter the True Estimate minimum value as per the Agency Agreement. Example: $1,250,000',
        error: true,
      });
      return;
    }
    if (contractsale === '') {
      setErrorMessageContract({
        helperText: 'Vendor full legal name / entity information required',
        error: true,
      });
      vendornameref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (contractMedia.length < 1) {
      setErrorMessageContractMedia('No Contract of Sale uploaded');
      setContractValidation(true);
      contractdocref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }

    if (errorMessageEmail.error || errorMessageNumber.error || !isValidEmail) {
      return;
    }
    setLoading(true);
    let sliderdata = `${roundForApi(slidervalue[0])} - ${roundForApi(
      slidervalue[1]
    )}`;
    let tempid =
      fromHeader == 'no' && resumeTempId != 0 && resumeTempId != undefined
        ? resumeTempId
        : localStorage.getItem('tempid');

    const params = {
      legalRep: {
        firstName:
          firstNameval.charAt(0).toUpperCase() + firstNameval.slice(1)?.trim(),
        lastName:
          lastNameval.charAt(0).toUpperCase() + lastNameval.slice(1)?.trim(),
        address:
          (unitNumber
            ? `${unitNumber}` + `${streetNumber == '' ? '' : '/'}`
            : '') +
          `${streetNumber}` +
          `${streetName == '' ? '' : ' '}` +
          `${streetName}` +
          `${selectedStreetType == '' ? '' : ' '}` +
          `${selectedStreetType}` +
          `${town === '' ? '' : ', '}` +
          `${town}` +
          `${postCode === '' ? '' : ', '}` +
          `${postCode}` +
          `${selectedState === '' ? '' : ', '}` +
          `${selectedState}`,
        mobile: mobileval,
        email: emailval,
        trueEstimate: sliderdata,
        agreementDate: formattedDate,
        agreedComFee: commissionFee,
        agentMarketBud: agreedMarketingBudget,
        valueInput: agencyTrueEstimatePrice,
        legalConOfSale: contractsale,
        isIncludeGST: includesGST == true ? 1 : 0,
      },
      tempId: tempid,
      ...(pipelineTempId || localStorage.getItem('pipelinePropertyId')
        ? {
            pipelinePropertyId:
              pipelineTempId || localStorage.getItem('pipelinePropertyId'),
          }
        : {}),
    };

    postApiCall(ADD_PROPERTY_LEGAL, params)
      .then((res) => {
        if (res.data.status == -1) {
          setLoading(false);
          toast.error(res.data.message, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: 0,
            theme: 'light',
            style: {
              fontFamily: 'Poppins', // 👈 Inline Poppins font
            },
          });
        } else {
          setValue(value + 1);
          const formData = new FormData();
          media.forEach((item) => {
            formData.append('agencyAgreement[]', item);
          });

          contractMedia.forEach((item) => {
            formData.append('contractOfSale[]', item);
          });

          formData.append('tempId', res?.data?.tempId);

          postApiCall(ADD_PROPERTY_MEDIA, formData)
            .then((response) => {
              if (response.data.status == -1) {
                setLoading(false);
                toast.error(response.data.message, {
                  position: 'top-right',
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  progress: 0,
                  theme: 'light',
                  style: {
                    fontFamily: 'Poppins', // 👈 Inline Poppins font
                  },
                });
              } else {
                setLoading(false);
                dashboardcount?.();
              }
            })
            .catch(function (response) {
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  function ValueLabelComponent(props) {
    const { children, open, value } = props;

    return (
      <div
        style={{
          top: -30,
          position: 'relative',
          color: 'white',
          textAlign: 'center',
        }}
      >
        <Typography variant="caption" style={{ fontWeight: 'bold' }}>
          {value}
        </Typography>
        {children}
      </div>
    );
  }
  const matches = useMediaQuery('(min-width:1200px) and (max-width:1400px)');
  const isSmallScreen = useMediaQuery(
    '(min-width:1200px) and (max-width:1260px)'
  );
  return (
    <form
      method="post"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography className={classes.LegalTitle}>
            Legal Representative
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={matches ? 6 : 3} xl={3}>
          <FormLabel required sx={typography_textfield} variant="h6">
            First Name
          </FormLabel>
          <TextField
            required
            sx={{
              ...textboxmargin,
              '& .MuiInputBase-input::placeholder': {
                textTransform: 'none',
              },
            }}
            fullWidth
            ref={firstnameref}
            helperText={errorMessage.helperText}
            error={errorMessage.error}
            placeholder="Enter your first name"
            id="firstName"
            type="text"
            name="firstName"
            autoComplete="off"
            onKeyDown={handleKeyDown}
            value={firstNameval}
            onFocus={() => {
              setLastNameAnchor(false);
              setMobileAnchor(false);
              setEmailAnchor(false);
            }}
            onBlur={() => setTimeout(() => setFirstNameAnchor(false), 200)}
            onChange={(event) => {
              const inputValue = event.target.value;
              // const alphabetOnly = inputValue.replace(
              //   /[^a-zA-Z\s]/g,
              //   ""
              // );
              const alphabetOnly = inputValue
                .replace(/[^a-zA-Z\s]/g, '')
                .slice(0, 30);

              let formatted =
                alphabetOnly.charAt(0).toUpperCase() +
                alphabetOnly.slice(1).toLowerCase();

              event.target.value = formatted.trimStart();
              if (formatted.trimStart().length > 0) {
                solicitorCheckin(formatted.trimStart());
                setFirstNameAnchor(true);
              } else {
                setFirstNameAnchor(false);
              }
              setFirstNameval(formatted.trimStart());
              setErrorMessage({
                helperText: '',
                error: false,
              });
            }}
            inputProps={{
              maxLength: 25,
              style: { fontFamily: 'poppins', textTransform: 'capitalize' },
            }}
          />
          <Box sx={{ position: 'relative', display: 'block' }}>
            {firstNameAnchor && !checkInErrorData && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%', // Positioned just below the TextField
                  right: 0, // Align with the TextField's left edge
                  minWidth: '320px',
                  maxHeight: '270px',
                  overflowY: 'auto', // Scroll only the list of users
                  overflowX: 'hidden',
                  // borderRadius: "8px",
                  boxShadow: 3,
                  // paddingTop: 2,

                  backgroundColor: '#fff',
                  zIndex: 1000,
                  display: 'flex',
                  flexDirection: 'column',
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                {/* Scrollable list of users */}
                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: 'scroll',
                    maxHeight: '150px',
                    paddingLeft: 2,
                    paddingTop: 2,
                    scrollbarWidth: 'thin !important',
                    '&:hover': {
                      overflowY: 'scroll',
                    },
                    '&::-webkit-scrollbar': {
                      display: 'block !important',
                      scrollbarWidth: 'thin !important',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#888 !important',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555 !important',
                    },
                  }}
                >
                  {checkInData &&
                  Array.isArray(checkInData?.userData) &&
                  checkInData?.userData.length > 0 ? (
                    <>
                      {checkInData.userData.map((dataItem, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: 1,
                            padding: 1,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setFirstNameval(
                              checkInData?.userData[i]?.userName || ''
                            );
                            setLastNameval(
                              checkInData?.userData[i]?.userSurName || ''
                            );
                            setMobileval(
                              checkInData?.userData[i]?.userPhone || ''
                            );
                            setEmailval(
                              checkInData?.userData[i]?.userEmail || ''
                            );
                            validateAndFormatMobile(
                              checkInData?.userData[i]?.userPhone
                            );
                            validateEmail(checkInData?.userData[i]?.userEmail);

                            setSelectedSolicitorAddress(
                              checkInData?.userData[i]?.address || ''
                            );
                            setCheckInIndex('1');
                            setUserSelected(true);
                            setUserSelected(true);
                            setFirstNameAnchor(false);
                            // setAnchorEl('');
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontWeight: 500,
                              fontSize: '14px',
                              color: '#666',
                            }}
                          >
                            {`${dataItem.userName} ${dataItem.userSurName}`}
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '12px',
                              color: '#999',
                            }}
                          >
                            {dataItem.userEmail}
                          </Typography>
                        </Box>
                      ))}
                    </>
                  ) : (
                    <Typography>No existing contact available</Typography>
                  )}
                </Box>
                <Divider />
                {/* Fixed "Add this as new contact" section */}
                <Box
                  sx={{
                    paddingTop: 1,
                    paddingBottom: 1,
                    textAlign: 'center',
                  }}
                  onClick={() => {
                    closeAllAnchors();
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      color: '#007BFF',
                      cursor: 'pointer',
                    }}
                  >
                    {`+ Add this '${firstNameval}' as new contact`}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={matches ? 6 : 3} xl={3}>
          <FormLabel required sx={typography_textfield} variant="h6">
            Last Name
          </FormLabel>
          <TextField
            required
            sx={{
              ...textboxmargin,
              '& .MuiInputBase-input::placeholder': {
                textTransform: 'none',
              },
            }}
            fullWidth
            ref={lastnameref}
            helperText={errorMessageLastName.helperText}
            error={errorMessageLastName.error}
            placeholder="Enter your last name"
            id="lastName"
            type="text"
            name="lastName"
            autoComplete="off"
            onKeyDown={handleKeyDown}
            value={lastNameval}
            onFocus={() => {
              setFirstNameAnchor(false);
              setMobileAnchor(false);
              setEmailAnchor(false);
              // setAnchorEl('');
            }}
            onBlur={() => setTimeout(() => setLastNameAnchor(false), 200)}
            onChange={(event) => {
              const inputValue = event.target.value;

              const alphabetOnly = inputValue
                .replace(/[^a-zA-Z\s]/g, '')
                .slice(0, 30);
              let formatted =
                alphabetOnly.charAt(0).toUpperCase() +
                alphabetOnly.slice(1).toLowerCase();
              event.target.value = formatted.trimStart();
              if (formatted.trimStart().length > 0) {
                solicitorCheckin(formatted.trimStart());
                setLastNameAnchor(true);
              } else {
                setLastNameAnchor(false);
              }
              setLastNameval(formatted.trimStart());
              setErrorMessageLastName({
                helperText: '',
                error: false,
              });
            }}
            inputProps={{
              maxLength: 25,
              style: { fontFamily: 'poppins', textTransform: 'capitalize' },
            }}
          />
          <Box sx={{ position: 'relative', display: 'block' }}>
            {lastNameAnchor && !checkInErrorData && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '100%', // Positioned just below the TextField
                  right: 0, // Align with the TextField's left edge
                  minWidth: '320px',
                  maxHeight: '270px',
                  overflowY: 'auto', // Scroll only the list of users
                  overflowX: 'hidden',
                  // borderRadius: "8px",
                  boxShadow: 3,
                  // paddingTop: 2,

                  backgroundColor: '#fff',
                  zIndex: 1000,
                  display: 'flex',
                  flexDirection: 'column',
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                {/* Scrollable list of users */}
                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: 'scroll',
                    maxHeight: '150px',
                    paddingLeft: 2,
                    paddingTop: 2,
                    scrollbarWidth: 'thin !important',
                    '&:hover': {
                      overflowY: 'scroll',
                    },
                    '&::-webkit-scrollbar': {
                      display: 'block !important',
                      scrollbarWidth: 'thin !important',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#888 !important',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555 !important',
                    },
                  }}
                >
                  {checkInData &&
                  Array.isArray(checkInData?.userData) &&
                  checkInData?.userData.length > 0 ? (
                    <>
                      {checkInData.userData.map((dataItem, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: 1,
                            padding: 1,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setFirstNameval(
                              checkInData?.userData[i]?.userName || ''
                            );
                            setLastNameval(
                              checkInData?.userData[i]?.userSurName || ''
                            );
                            setMobileval(
                              checkInData?.userData[i]?.userPhone || ''
                            );
                            setEmailval(
                              checkInData?.userData[i]?.userEmail || ''
                            );
                            validateAndFormatMobile(
                              checkInData?.userData[i]?.userPhone
                            );
                            validateEmail(checkInData?.userData[i]?.userEmail);

                            // for address split
                            const fullAddress =
                              checkInData?.userData[i]?.address || '';
                            if (fullAddress) {
                              const parts = fullAddress
                                .split(',')
                                .map((p) => p.trim());

                              const streetParts = parts[0].split(' ');
                              const number = streetParts[0];
                              const type =
                                streetParts[streetParts.length - 1] || '';
                              const name = streetParts.slice(1, -1).join(' ');
                              const suburb = parts[1] || '';
                              const pin = parts[2] || '';
                              const cityName = parts[3] || '';

                              // Set parsed address fields
                              setStreetNumber(number);
                              setStreetName(name);
                              setSelectedStreetType(type);
                              const matchedOption = options.find(
                                (opt) => opt.label === type
                              );
                              if (matchedOption) {
                                setSelectedStreetTypeformat(matchedOption);
                              }
                              setTown(suburb);
                              setPostCode(pin);
                              setSelectedState(cityName);
                            }

                            setCheckInIndex('1');
                            setUserSelected(true);
                            // setAnchorEl('');
                            setLastNameAnchor(false);
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontWeight: 500,
                              fontSize: '14px',
                              color: '#666',
                            }}
                          >
                            {`${dataItem.userName} ${dataItem.userSurName}`}
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '12px',
                              color: '#999',
                            }}
                          >
                            {dataItem.userEmail}
                          </Typography>
                        </Box>
                      ))}
                    </>
                  ) : (
                    <Typography>No existing contact available</Typography>
                  )}
                </Box>
                <Divider />
                {/* Fixed "Add this as new contact" section */}
                <Box
                  sx={{
                    paddingTop: 1,
                    paddingBottom: 1,
                    textAlign: 'center',
                  }}
                  onClick={() => {
                    closeAllAnchors();
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      color: '#007BFF',
                      cursor: 'pointer',
                    }}
                  >
                    {`+ Add this '${lastNameval}' as new contact`}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>

          {/* {errorMessage && <div>{errorMessage.error}</div>} */}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={matches ? 6 : 3} xl={3}>
          <FormLabel required sx={typography_textfield} variant="h6">
            Mobile
          </FormLabel>
          <TextField
            required
            fullWidth
            placeholder="Enter your mobile phone number"
            // id="mobile"
            id="mobile-input"
            name="mobile"
            autoComplete="off"
            ref={mobileref}
            sx={{
              ...textboxmargin,
              '& .MuiInputBase-input::placeholder': {
                textTransform: 'none',
              },
            }}
            value={mobileval}
            onFocus={() => {
              setFirstNameAnchor(false);
              setLastNameAnchor(false);
              setEmailAnchor(false);
            }}
            onBlur={() => setTimeout(() => setMobileAnchor(false), 200)}
            onChange={(event) => {
              setMobileval(event.target.value);
              handleMobileChange(event);
              if (event.target.value.length > 0) {
                solicitorCheckin(event.target.value);
                setMobileAnchor(true);
              } else {
                setMobileAnchor(false);
              }
            }}
            inputProps={{ maxLength: 12 }}
            error={errorMessageNumber.error}
            helperText={errorMessageNumber.helperText}
          />
        </Grid>
        {/* suggestioins under mobile field */}
        <Box sx={{ position: 'relative', display: 'block' }}>
          {mobileAnchor && !checkInErrorData && (
            <Box
              sx={{
                position: 'absolute',
                top: '100%', // Positioned just below the TextField
                right: 0, // Align with the TextField's left edge
                minWidth: '320px',
                maxHeight: '270px',
                overflowY: 'auto', // Scroll only the list of users
                overflowX: 'hidden',
                // borderRadius: "8px",
                boxShadow: 3,
                // paddingTop: 2,

                backgroundColor: '#fff',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              {/* Scrollable list of users */}
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: 'scroll',
                  maxHeight: '150px',
                  paddingLeft: 2,
                  paddingTop: 2,
                  scrollbarWidth: 'thin !important',
                  '&:hover': {
                    overflowY: 'scroll',
                  },
                  '&::-webkit-scrollbar': {
                    display: 'block !important',
                    scrollbarWidth: 'thin !important',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888 !important',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555 !important',
                  },
                }}
              >
                {checkInData &&
                Array.isArray(checkInData?.userData) &&
                checkInData?.userData.length > 0 ? (
                  <>
                    {checkInData.userData.map((dataItem, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          marginBottom: 1,
                          padding: 1,
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setFirstNameval(
                            checkInData?.userData[i]?.userName || ''
                          );
                          setLastNameval(
                            checkInData?.userData[i]?.userSurName || ''
                          );
                          setMobileval(
                            checkInData?.userData[i]?.userPhone || ''
                          );
                          setEmailval(
                            checkInData?.userData[i]?.userEmail || ''
                          );
                          validateAndFormatMobile(
                            checkInData?.userData[i]?.userPhone
                          );
                          validateEmail(checkInData?.userData[i]?.userEmail);

                          // for address split
                          const fullAddress =
                            checkInData?.userData[i]?.address || '';
                          if (fullAddress) {
                            const parts = fullAddress
                              .split(',')
                              .map((p) => p.trim());

                            const streetParts = parts[0].split(' ');
                            const number = streetParts[0];
                            const type =
                              streetParts[streetParts.length - 1] || '';
                            const name = streetParts.slice(1, -1).join(' ');
                            const suburb = parts[1] || '';
                            const pin = parts[2] || '';
                            const cityName = parts[3] || '';

                            // Set parsed address fields
                            setStreetNumber(number);
                            setStreetName(name);
                            setSelectedStreetType(type);
                            const matchedOption = options.find(
                              (opt) => opt.label === type
                            );
                            if (matchedOption) {
                              setSelectedStreetTypeformat(matchedOption);
                            }
                            setTown(suburb);
                            setPostCode(pin);
                            setSelectedState(cityName);
                          }

                          setCheckInIndex('1');
                          setUserSelected(true);
                          setMobileAnchor(false);
                          // setAnchorEl('');
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontWeight: 500,
                            fontSize: '14px',
                            color: '#666',
                          }}
                        >
                          {`${dataItem.userName} ${dataItem.userSurName}`}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontSize: '12px',
                            color: '#999',
                          }}
                        >
                          {dataItem.userEmail}
                        </Typography>
                      </Box>
                    ))}
                  </>
                ) : (
                  <Typography>No existing contact available</Typography>
                )}
              </Box>
              <Divider />
              {/* Fixed "Add this as new contact" section */}
              <Box
                sx={{
                  paddingTop: 1,
                  paddingBottom: 1,
                  textAlign: 'center',
                }}
                onClick={() => {
                  closeAllAnchors();
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    color: '#007BFF',
                    cursor: 'pointer',
                  }}
                >
                  {`+ Add this '${mobileval}' as new contact`}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        <Grid item xs={12} sm={12} md={6} lg={matches ? 6 : 3} xl={3}>
          <FormLabel required sx={typography_textfield} variant="h6">
            Email
          </FormLabel>
          <TextField
            required
            sx={{
              ...textboxmargin,
              '& .MuiInputBase-input::placeholder': {
                textTransform: 'none',
              },
            }}
            fullWidth
            // helperText={errorMessageEmail.helperText}
            helperText={
              !isValidEmail ? (
                <span
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '16',
                    color: '#d32f2f',
                  }}
                >
                  Invalid email format
                </span>
              ) : (
                errorMessageEmail.helperText
              )
            }
            error={errorMessageEmail.error || !isValidEmail}
            inputRef={emailInputRef}
            placeholder="name@Example:.com.au"
            id="email"
            type="input"
            name="email"
            autoComplete="off"
            ref={emailref}
            value={emailval}
            onFocus={() => {
              setFirstNameAnchor(false);
              setLastNameAnchor(false);
              setMobileAnchor(false);
            }}
            onBlur={() => setTimeout(() => setEmailAnchor(false), 200)}
            onKeyDown={(e) => {
              if (e.key === ' ') {
                e.preventDefault();
              }
            }}
            // onChange={(event) => {
            //   handleEmailChange(event);
            //   const inputValue = event.target.value;
            //   setEmailval(inputValue);
            //   if (event.target.type !== "text") {
            //     setErrorMessageEmail({
            //       helperText:
            //         "Invalid format: should contain only text",
            //       error: true,
            //     });
            //   } else {
            //     setErrorMessageEmail({
            //       helperText: "",
            //       error: false,
            //     });
            //   }
            // }}
            //             onChange={(event) => {
            //   handleEmailChange(event);
            //   const inputValue = event.target.value.toLowerCase(); // ✅ apply lowercase
            //   setEmailval(inputValue);
            //   if (event.target.type !== "text") {
            //     setErrorMessageEmail({
            //       helperText: "Invalid format: should contain only text",
            //       error: true,
            //     });
            //   } else {
            //     setErrorMessageEmail({
            //       helperText: "",
            //       error: false,
            //     });
            //   }
            // }}

            onChange={(event) => {
              const input = event.target;

              // Preserve current cursor position
              const selectionStart = input.selectionStart;
              const selectionEnd = input.selectionEnd;

              const originalValue = input.value;
              const lowerCasedValue = originalValue.toLowerCase();

              // Calculate adjustment in cursor position due to casing change
              const diff = originalValue.length - lowerCasedValue.length;

              // Set the transformed value
              setEmailval(lowerCasedValue);

              // Your custom logic
              handleEmailChange(event);
              solicitorCheckin(lowerCasedValue);
              closeAllAnchors();
              if (lowerCasedValue.length > 0) {
                setEmailAnchor(true);
              } else {
                setEmailAnchor(false);
              }

              // Restore cursor in a microtask to avoid re-render timing issue
              queueMicrotask(() => {
                try {
                  if (input && document.activeElement === input) {
                    input.setSelectionRange(
                      selectionStart - diff,
                      selectionEnd - diff
                    );
                  }
                } catch (err) {
                  console.warn('Cursor reset failed', err);
                }
              });

              // Error handling
              if (input.type !== 'text') {
                setErrorMessageEmail({
                  helperText: 'Invalid format: should contain only text',
                  error: true,
                });
              } else {
                setErrorMessageEmail({
                  helperText: '',
                  error: false,
                });
              }
            }}
          />
          {/* {errorMessageEmail && <div>{errorMessageEmail.error}</div>} */}
        </Grid>

        {/* suggestion for email */}

        <Box sx={{ position: 'relative', display: 'block' }}>
          {emailAnchor && !checkInErrorData && (
            <Box
              sx={{
                position: 'absolute',
                top: '100%', // Positioned just below the TextField
                right: 0, // Align with the TextField's left edge
                minWidth: '320px',
                maxHeight: '270px',
                overflowY: 'auto', // Scroll only the list of users
                overflowX: 'hidden',
                // borderRadius: "8px",
                boxShadow: 3,
                // paddingTop: 2,

                backgroundColor: '#fff',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              {/* Scrollable list of users */}
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: 'scroll',
                  maxHeight: '150px',
                  paddingLeft: 2,
                  paddingTop: 2,
                  scrollbarWidth: 'thin !important',
                  '&:hover': {
                    overflowY: 'scroll',
                  },
                  '&::-webkit-scrollbar': {
                    display: 'block !important',
                    scrollbarWidth: 'thin !important',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888 !important',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555 !important',
                  },
                }}
              >
                {checkInData &&
                Array.isArray(checkInData?.userData) &&
                checkInData?.userData.length > 0 ? (
                  <>
                    {checkInData.userData.map((dataItem, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          marginBottom: 1,
                          padding: 1,
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setFirstNameval(
                            checkInData?.userData[i]?.userName || ''
                          );
                          setLastNameval(
                            checkInData?.userData[i]?.userSurName || ''
                          );
                          setMobileval(
                            checkInData?.userData[i]?.userPhone || ''
                          );
                          setEmailval(
                            checkInData?.userData[i]?.userEmail || ''
                          );
                          validateAndFormatMobile(
                            checkInData?.userData[i]?.userPhone
                          );
                          validateEmail(checkInData?.userData[i]?.userEmail);

                          // for address split
                          const fullAddress =
                            checkInData?.userData[i]?.address || '';
                          if (fullAddress) {
                            const parts = fullAddress
                              .split(',')
                              .map((p) => p.trim());

                            const streetParts = parts[0].split(' ');
                            const number = streetParts[0];
                            const type =
                              streetParts[streetParts.length - 1] || '';
                            const name = streetParts.slice(1, -1).join(' ');
                            const suburb = parts[1] || '';
                            const pin = parts[2] || '';
                            const cityName = parts[3] || '';

                            // Set parsed address fields
                            setStreetNumber(number);
                            setStreetName(name);
                            setSelectedStreetType(type);
                            const matchedOption = options.find(
                              (opt) => opt.label === type
                            );
                            if (matchedOption) {
                              setSelectedStreetTypeformat(matchedOption);
                            }
                            setTown(suburb);
                            setPostCode(pin);
                            setSelectedState(cityName);
                          }

                          setCheckInIndex('1');
                          setUserSelected(true);
                          setEmailAnchor(false);
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontWeight: 500,
                            fontSize: '14px',
                            color: '#666',
                          }}
                        >
                          {`${dataItem.userName} ${dataItem.userSurName}`}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontSize: '12px',
                            color: '#999',
                          }}
                        >
                          {dataItem.userEmail}
                        </Typography>
                      </Box>
                    ))}
                  </>
                ) : (
                  <Typography>No existing contact available</Typography>
                )}
              </Box>
              <Divider />
              {/* Fixed "Add this as new contact" section */}
              <Box
                sx={{
                  paddingTop: 1,
                  paddingBottom: 1,
                  textAlign: 'center',
                }}
                onClick={() => {
                  closeAllAnchors();
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    color: '#007BFF',
                    cursor: 'pointer',
                  }}
                >
                  {`+ Add this '${emailval}' as new contact`}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <FormLabel required sx={typography_textfield} variant="h6">
              Address
            </FormLabel>
            <PropertyAddressField
              latitude={latitude}
              setLatitude={setLatitude}
              longitude={longitude}
              setLongitude={setLongitude}
              unitNumber={unitNumber}
              setUnitNumber={setUnitNumber}
              streetNumber={streetNumber}
              setStreetNumber={setStreetNumber}
              streetName={streetName}
              setStreetName={setStreetName}
              selectedStreetType={selectedStreetType}
              setSelectedStreetType={setSelectedStreetType}
              town={town}
              setTown={setTown}
              selectedState={selectedState}
              setSelectedState={setSelectedState}
              postCode={postCode}
              setPostCode={setPostCode}
              options={options}
              setErrorforaddress={setErrorMessageAddress}
              errorforaddress={errorMessageAddress}
              addressref={addressref}
              fromlegal={true}
              solicitorAddress={selectedSolicitorAddress}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Typography className={classes.LegalTitle}>
            Agency Agreement Details
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormLabel
            required
            sx={{
              ...typography_textfield,
              display: 'block',
              lineHeight: '1.4',
              mb: 1,
            }}
          >
            Upload Agency Agreement
          </FormLabel>
        </Grid>
        {!media.length > 0 && (
          <Grid
            gap={2}
            item
            xs={12}
            sm={12}
            md={2.3}
            lg={2.3}
            xl={2.3}
            onClick={() => {
              if (media.length > 2) {
                setErrorMessageAgencyMedia({
                  helperText: 'Only 3 Agency Agreement Documents are allowed',
                  error: true,
                });
              }
            }}
            ref={agencyagreementref}
          >
            <DropZone
              sx={{ border: pdfValidation && '1px solid #d32f2f' }}
              {...getRootProps()}
              isDragAccept={isDragAccept}
              isDragReject={isDragReject}
            >
              <p className={classes.pdfUploadText}>
                {isDragAccept ? (
                  'All files are accepted'
                ) : isDragReject ? (
                  'Some files are rejected'
                ) : (
                  <>
                    <AddCircleOutlineIcon
                      style={{
                        color: pdfValidation ? '#d32f2f' : '#965CF0',
                        fontSize: '25px',
                      }}
                    />
                    <br />
                    <span
                      style={{ color: pdfValidation ? '#d32f2f' : '#965CF0' }}
                    >
                      Upload or Drag here
                    </span>
                  </>
                )}
              </p>
              <input
                {...getInputProps()}
                style={{ display: 'inline-block', opacity: 0, width: '2px' }}
                required={media.length < 1}
                multiple
              />
            </DropZone>
          </Grid>
        )}
        {media.map((file, index) => (
          <Grid
            style={{ display: 'flex', flexWrap: 'wrap' }}
            className={classes.MaxPdfBox}
            item
            xs={12}
            sm={3}
            md={2.5}
            lg={2}
            xl={1.8}
            key={file.name}
          >
            <Box
              key={file.name}
              title={file.name}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <img
                src={PdfIcon}
                style={{ width: '150px', height: 'auto' }}
                alt="pdficon"
              />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  marginTop: '5px',
                }}
              >
                <span
                  style={{
                    fontSize: '14px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    wordWrap: 'break-word',
                    maxWidth: '150px',
                    textAlign: 'center',
                    lineHeight: '1.2',
                  }}
                >
                  {file.name}
                </span>
                <img
                  onClick={() => {
                    if (loading) return;

                    const updatedFiles = media.filter(
                      (f) => f.name !== file.name
                    );
                    setMedia(updatedFiles);

                    const noFilesLeft = updatedFiles.length < 1;

                    setErrorMessageAgencyMedia({
                      helperText: noFilesLeft
                        ? 'No agency agreement uploaded'
                        : '',
                      error: noFilesLeft,
                      duplicateNames: null,
                    });

                    setPdfValidation(noFilesLeft);
                    setErrorMessages('');
                  }}
                  src={DeleteIcon}
                  alt="pdficon"
                  style={{
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.5 : 1,
                    width: 'auto',
                    height: 'auto',
                  }}
                />
              </div>
            </Box>
          </Grid>
        ))}

        {media.length > 0 && media.length < MAX_FILE_COUNT && (
          <Grid
            item
            xs={6}
            sm={1.8}
            md={0.5}
            lg={1}
            xl={1}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Button
              style={{
                width: '50px',
                height: '45px',
                fontFamily: 'Poppins',
                textTransform: 'inherit',
                borderRadius: '5px',
                color: '#737497',
                background: '#f0e9fa',
                marginRight: '15px',
                fontSize: '28px',
                fontWeight: 300,
              }}
              onClick={handleButtonClickss}
            >
              +
            </Button>
            <div {...getRootProps()}>
              <input {...getInputProps()} ref={agencyagreementref} />
            </div>
          </Grid>
        )}
        <Grid
          style={{ display: 'flex', flexWrap: 'wrap' }}
          className={classes.MaxPdfBox}
          item
          xs={12}
        >
          <Box
            sx={{
              justifyContent: 'center',
              display: 'flex',
              marginTop: '-5px',
            }}
          >
            {errorMessages && (
              <Typography
                sx={{
                  color: '#d32f2f',
                  fontFamily: 'poppins',
                  marginTop: '5px',
                  fontSize: '12px',
                  wordBreak: 'break-word',
                }}
              >
                {errorMessages}
              </Typography>
            )}
            {errorMessageAgencyMedia?.helperText && (
              <Typography
                sx={{
                  color: '#d32f2f',
                  fontFamily: 'poppins',
                  marginTop: '-2px',
                  fontSize: '12px',
                  wordBreak: 'break-word',
                }}
              >
                {errorMessageAgencyMedia.helperText}
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid
          style={{ display: 'flex', marginTop: '-15px' }}
          className={classes.MaxPdfBox}
          item
          xs={12}
          sm={12}
          md={2}
          lg={2}
          xl={2}
        >
          <Typography className={classes.pdfUploadMaxText}>
            {media.length === 0 && (
              <>
                Upload PDF file only,
                <br />
                max size limit 15MB
              </>
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
        <Grid mb={2} item xs={12} sm={12} md={4} lg={4} xl={4}>
          <FormLabel sx={typography_textfield} required variant="h6">
            Date of Agreement
          </FormLabel>
          <div style={{ marginTop: '5px', height: matchessm ? '56px' : '' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                ref={dateofagreementref}
                required
                sx={
                  (pick_date,
                  {
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor:
                        errorMessageDateOfAgreement == ''
                          ? 'rgba(0, 85, 255, 0.64)'
                          : '#d32f2f',
                    },
                  })
                }
                minDate={dayjs(addMonths(new Date(), -6))}
                maxDate={todayInSydney.subtract(1, 'day')}
                format="DD-MM-YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !!errorMessageDateOfAgreement,
                    helperText: errorMessageDateOfAgreement,
                    required: true,
                    FormHelperTextProps: {
                      sx: {
                        ml: '-1px', // 👈 Add left margin to error text
                        mt: '4px', // (optional) small space above error
                      },
                    },
                  },
                }}
                value={dateOfAgreement ? dayjs(dateOfAgreement) : null}
                onChange={(newValue) => {
                  setErrorMessageDateOfAgreement('');
                  if (newValue && newValue.isValid()) {
                    let val = newValue.format('YYYY-MM-DD');
                    let today = todayInSydney.format('YYYY-MM-DD');
                    const differenceInTime =
                      todayInSydney.toDate().getTime() -
                      newValue.toDate().getTime();
                    const differenceInDays =
                      differenceInTime / (1000 * 3600 * 24);
                    if (val >= today) {
                      setDateOfAgreement(val);
                      setErrorMessageDateOfAgreement(
                        'You cannot able to enter current / future date'
                      );
                    } else if (differenceInDays > 180) {
                      setDateOfAgreement(val);
                      setErrorMessageDateOfAgreement(
                        'Date of Agreement cannot be more than 180 days backdated.'
                      );
                    } else {
                      setDateOfAgreement(val);
                    }
                  } else {
                    setDateOfAgreement('');
                    setErrorMessageDateOfAgreement(
                      'Date format should be DD-MM-YYYY'
                    );
                  }
                }}
              />
            </LocalizationProvider>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}></Grid>
        <Grid item xs={12} sm={12} md={5} lg={4} xl={4}>
          <FormLabel sx={typography_textfield} required variant="h6">
            Agreed Commission Fee (%)
          </FormLabel>
          <TextField
            required
            sx={textboxmargin}
            ref={commissionFeeref}
            inputRef={commissionFeeref}
            helperText={errorMessageAgreedCommission.helperText}
            error={errorMessageAgreedCommission.error}
            fullWidth
            placeholder="Example: 1.45%"
            id="commissionFee"
            type="text"
            name="commissionFee"
            value={commissionFee}
            onChange={handleCommissionFeeChange}
            onBlur={handleCommissionFeeBlur}
            inputProps={{ maxLength: 5, style: { fontFamily: 'poppins' } }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} xl={1.5}>
          <Stack direction={'row'} alignItems={'end'} height={'100%'}>
            <Typography>
              <input
                type="checkbox"
                checked={includesGST}
                onClick={() => {
                  setIncludesGST(!includesGST);
                }}
              />
            </Typography>
            <InputLabel
              htmlFor="IncludesGST"
              sx={{ ...checkbox_style, p: '5px' }}
            >
              &nbsp; Includes GST
            </InputLabel>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={12} md={5} lg={4} xl={4}>
          <FormLabel sx={typography_textfield} required variant="h6">
            Agreed Marketing Budget ($)
          </FormLabel>
          <TextField
            required
            autoComplete="off"
            sx={textboxmargin}
            ref={marketingbudgetref}
            fullWidth
            placeholder="Example: $25,000"
            id="agreedMarketingBudget"
            // type="number"
            name="agreedMarketingBudget"
            value={formattedAgreedMarketingBudget}
            error={errorMessageAgreedMarketing.error}
            helperText={errorMessageAgreedMarketing.helperText}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
            onChange={handleAgreedMarketingBudgetChange}
            onKeyPress={handleKey}
            inputProps={{ maxLength: 7, style: { fontFamily: 'poppins' } }}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={8} lg={5} xl={4}>
          <FormLabel
            sx={{
              ...typography_textfield,
              fontSize: isSmallScreen ? '18px' : typography_textfield.fontSize,
            }}
            required
            variant="h6"
          >
            Agency Agreement True Estimate Price ($)
          </FormLabel>
          <TextField
            required
            sx={textboxmargin}
            ref={estimatepriceref}
            fullWidth
            autoComplete="off"
            error={errorMessageAgencyAgreement.error}
            helperText={errorMessageAgencyAgreement.helperText}
            placeholder="Example: $25,000"
            id="agencyTrueEstimatePrice"
            // type="number"
            name="agencyTrueEstimatePrice"
            value={formattedAgencyTrueEstimatePrice}
            onKeyPress={handleKey}
            onChange={handleTextFieldChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
            // onChange={handleAgencyTrueEstimatePriceChange}
            inputProps={{ maxLength: 11, style: { fontFamily: 'poppins' } }}
          />
        </Grid>
        <Grid mt={4} item xs={12}>
          <FormLabel sx={typography_textfield} variant="h6">
            Agency Agreement True Estimate Range
          </FormLabel>

          <Box
            sx={{
              paddingTop: '20px',
              width: matches700 ? '70%' : matches1200 ? '75%' : '97%',
              margin: '0 auto',
            }}
          >
            <AirbnbSlider
              required
              slots={{ thumb: AirbnbThumbComponent }}
              value={slidervalue} // Use value instead of default
              disable={
                !slidervalue.includes(slidervalue[0]) &&
                !slidervalue.includes(slidervalue[1])
              }
              // min={0}
              min={minSliderValue}
              // step={
              //   slidervalue[0] == 2000000 || slidervalue[1] == 2000000
              //     ? 50000
              //     : 10000
              // }
              step={
                slidervalue[0] < 100000
                  ? 1000
                  : slidervalue[0] < 1000000
                  ? 10000
                  : 50000
              }
              max={maxSliderValue}
              valueLabelDisplay="on"
              // ValueLabelComponent={ValueLabelComponent}
              ValueLabelComponent={CustomValueLabel}
              getAriaValueText={(value) => valueLabelFormat(value, false)}
              valueLabelFormat={(value) => valueLabelFormat(value, false)}
              // onChangeCommitted={handleChange}
              onChange={handleSliderChange}
              // marks={marks}
            />
            <style jsx>
              {`
                .MuiSlider-thumb[data-index='0'] .MuiSlider-valueLabelLabel {
                  padding-right: 70px !important;
                }
                .MuiSlider-thumb[data-index='1'] .MuiSlider-valueLabelLabel {
                  padding-left: ${matches1200 ? '30px' : '70px'} !important;
                }
              `}
            </style>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} xl={2} mb={2}></Grid>

        <Grid item xs={12} sm={12} md={12} marginTop={matchesmd ? -2 : ''}>
          <Typography className={classes.LegalTitle}>
            Sale Contract Details
          </Typography>
        </Grid>

        <Grid
          item
          mt={2}
          mb={3}
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          marginTop={matchesmd ? -1 : ''}
        >
          <FormLabel required sx={typography_textfield} variant="h6">
            Vendor Name on the Contract of Sale
          </FormLabel>
          <TextField
            required
            ref={vendornameref}
            sx={textboxmargin_description}
            fullWidth
            helperText={errorMessageContract.helperText}
            error={errorMessageContract.error}
            placeholder="Enter the Vendor's full legal name including any Company / Trust Names. 
 Example:: 
 Property Company Pty Ltd ACN 456 789 654 ATF Capital Holdings Pty Ltd ACN 123 456 789
 OR
 Mr Jason George Smtih & Mrs Helen Smith"
            id="legal"
            type="input"
            multiline={true}
            rows={5}
            // onKeyDown={handleKeyDown}
            name="legal"
            value={contractsale}
            onChange={handleInputChange}
            inputProps={{
              // maxLength: 700, // Limit the maximum number of characters
              style: { fontFamily: 'poppins', textTransform: 'capitalize' },
            }}
          />
          {/* {errorMessageContract && (
            <div>{errorMessageContract.error}</div>
          )} */}
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormLabel required sx={typography_textfield}>
            Contract of Sale
          </FormLabel>
        </Grid>
        {!contractMedia.length > 0 && (
          <Grid
            gap={2}
            item
            xs={12}
            sm={12}
            md={2.5}
            lg={2.3}
            xl={2.3}
            marginTop={matchesmd ? -1.4 : ''}
            onClick={() => {
              if (contractMedia.length > 0) {
                setErrorMessageContractMedia(
                  'Only 1 Contract of Sale document can be uploaded'
                );
              }
            }}
            ref={contractdocref}
          >
            <DropZone
              sx={{ border: contractValidation && '1px solid #d32f2f' }}
              {...getContractProps()}
              isDragAccept={isDragAccept}
              isDragReject={isDragReject}
            >
              <p className={classes.pdfUploadText}>
                {isDragAccept ? (
                  'All files are accepted'
                ) : isDragReject ? (
                  'Some files are rejected'
                ) : (
                  <>
                    <AddCircleOutlineIcon
                      style={{
                        color: contractValidation ? '#d32f2f' : '#965CF0',
                        fontSize: '25px',
                      }}
                    />
                    <br />{' '}
                    <span
                      style={{
                        color: contractValidation ? '#d32f2f' : '#965CF0',
                      }}
                    >
                      Upload or Drag here
                    </span>
                  </>
                )}
                {/* {!isDragAccept && !isDragReject && <AddIcon style={{width:'100px'}}/>} */}
              </p>
              <input
                {...getContractInputProps()}
                style={{ display: 'inline-block', opacity: 0, width: '2px' }}
                required={contractMedia.length < 1}
                disabled={contractMedia.length == 1}
              />
              {/* Display the list of accepted files with delete buttons */}
            </DropZone>
            {errorMessageContractMedia && (
              <Typography
                sx={{
                  color: '#d32f2f',
                  fontFamily: 'poppins',
                  marginTop: '5px',
                  fontSize: '12px',
                  marginTop: '-10px',
                }}
              >
                {errorMessageContractMedia}
              </Typography>
            )}
          </Grid>
        )}

        {contractMedia.map((file) => (
          <Grid
            style={{ display: 'flex', flexWrap: 'wrap' }}
            className={classes.MaxPdfBox}
            item
            xs={12}
            sm={3}
            md={2.5}
            lg={2}
            xl={1.8}
          >
            <Box
              key={file.name}
              title={file.name}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <img
                src={PdfIcon}
                style={{ width: '150px', height: 'auto' }}
                alt="pdficon"
              />
              {/* <br /> */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  marginTop: '5px',
                }}
              >
                <span
                  style={{
                    fontSize: '14px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    wordWrap: 'break-word',
                    maxWidth: '150px',
                    textAlign: 'center',
                    lineHeight: '1.2',
                  }}
                >
                  {file.name}
                </span>
                <img
                  onClick={(e) => {
                    if (loading) return; // ✅ block click when disabled
                    setContractMedia((prevFiles) =>
                      prevFiles.filter((f) => f.name !== file.name)
                    );
                    setErrorMessageContractMedia('');
                  }}
                  src={DeleteIcon}
                  style={{
                    width: 'auto',
                    height: 'auto',
                    cursor: loading ? 'not-allowed' : 'pointer', // visual disable
                    opacity: loading ? 0.5 : 1, // faded look
                    display: 'inline-block',
                  }}
                  alt="pdficon"
                  disabled={loading} // ✅ you can keep this, React will pass it but <img> ignores it
                />
              </div>
            </Box>
          </Grid>
        ))}

        <Grid
          style={{ display: 'flex' }}
          className={classes.MaxPdfBox}
          item
          xs={12}
          sm={12}
          md={2}
          lg={2}
          xl={2}
        >
          <Typography className={classes.pdfUploadMaxText}>
            {contractMedia.length === 0 && (
              <>
                Upload PDF file only,
                <br />
                max size limit 15MB
              </>
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
        <Grid
          sx={{ marginBottom: matches700 && '50px' }}
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
        >
          <Box
            // className={classes.buttonBox}
            sx={{
              display: 'flex',
              justifyContent: 'end',
              gap: '20px',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            <Button
              disabled={loading}
              variant="outlined"
              // className={classes.cancelBtn}
              sx={{
                ...poppins500,
                fontSize: '16px',
                color: 'black',
                // width: "210px",
                // height: "48px",
                background: '#FFFFFF',
                whiteSpace: 'nowrap',
                border: '1px solid #DFDFDF',
                borderRadius: '8px',
                textTransform: 'inherit',
                padding: matches700 ? '5px 25px' : '12px 76px 12px 76px',
                ' &:hover': {
                  backgroundColor: '#FFFFFF !important',
                  color: '#6C2AD2',
                  border: '1px solid #6C2AD2 !important ',
                },
              }}
              onClick={() => onClose()}
            >
              Cancel
            </Button>
            <Button
              disabled={loading}
              // type="submit"
              variant="outlined"
              // className={classes.nextBtn}
              sx={{
                backgroundColor: '#965CF0 !important',
                ...poppins500,
                color: '#FFFFFF !important',
                fontSize: '16px',
                borderRadius: '8px',
                whiteSpace: 'nowrap',
                // width: "210px",
                // height: "48px",
                textTransform: 'inherit',
                padding: matches700 ? '5px 25px' : '12px 76px 12px 76px',
                border: '1px solid #AF05FF !important',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                ' &:hover': {
                  backgroundColor: '#965CF0 !important',
                  border: '1px solid #AF05FF !important ',
                },
              }}
              // onClick={legaldetails}
              onClick={() => {
                legaldetails();
              }}
            >
              Next
            </Button>
            {loading && (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px', marginLeft: '10px' }}
              />
            )}
          </Box>
        </Grid>
      </Grid>
      <Dialog open={pdfErrorOpen || pdfErrorOpen1} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontFamily: 'Poppins', fontSize: '24px' }}>
          File exceeds 15mb limit!
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography>
              {pdfErrorFile || pdfErrorFile1} exceeds the limit! Please contact
              retreX support
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            className={classes.ModalnextBtn}
            sx={{ fontFamily: 'Poppins', fontSize: '16px' }}
            onClick={closeFunction}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}

const getMuiTheme = () =>
  createTheme({
    components: {
      MuiDialog: {
        styleOverrides: {
          root: {},
          // container: {
          //   width: '1500px !important'
          // },
        },
      },
    },
  });

const useStyles = makeStyles((theme) => ({
  noSpinArrows: {
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
      {
        '-webkit-appearance': 'none',
        margin: 0,
      },
  },
  LegalTitle: {
    fontSize: '24px !important',
    fontWeight: '500px !important',
    fontFamily: 'Poppins !important',
    textAlign: 'left !important',
    color: '#687999 !important',
    fontStyle: 'Medium !important',
    padding: '10px 0px 10px 0px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
      fontWeight: '500px !important',
      fontFamily: 'Poppins !important',
      textAlign: 'left !important',
      fontStyle: 'Medium !important',
      // padding: '10px 0px 10px 0px !important',
    },
  },
  GridRow: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  pdfUploadMaxText: {
    fontFamily: 'Poppins !important',
    fontSize: '12px !important',
    listStyle: 'none',
    textAlign: 'center',
  },
  pdfUploadText: {
    fontFamily: 'Poppins !important',
    fontSize: '14px !important',
    textAlign: 'center',
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  MaxPdfSize: {
    display: 'block',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Poppins !important',
    textAlign: 'center',
  },
  MaxPdfBox: {
    justifyContent: 'start',
    alignItems: 'center',
    textAlign: 'center',
  },
  AdditionalOwner: {
    fontFamily: 'Poppins !important',
    fontSize: '16px',
    color: 'black',
    width: '351px',
    height: '48px',
    margin: '10px !important',
    background: '#FFFFFF',
    border: '1px solid #DFDFDF',
    borderRadius: '8px',
    textTransform: 'none !important',
    padding: '12px 73px 12px 73px',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2',
      border: '1px solid #6C2AD2 !important ',
    },
    [theme.breakpoints.down('md')]: {
      width: 'auto !important',
      height: '48px',
    },
  },
  AgreementTitle: {
    fontSize: '20px !important',
    fontWeight: '500px !important',
    fontStyle: 'large !important',
    fontFamily: 'Poppins !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
      fontWeight: '500px !important',
      fontFamily: 'Poppins !important',
      fontStyle: 'Medium !important',
    },
  },
  nextBtn: {
    margin: '10px !important',
    backgroundColor: '#965CF0 !important',
    fontFamily: 'Poppins !important',
    color: '#FFFFFF !important',
    fontSize: '16px',
    borderRadius: '8px !important',
    width: '210px',
    height: '48px',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    border: '1px solid #AF05FF !important',
    ' &:hover': {
      backgroundColor: '#965CF0 !important',
      border: '1px solid #AF05FF !important ',
    },
  },
  cancelBtn: {
    fontSize: '16px',
    fontFamily: 'Poppins !important',
    color: '#000 !important',
    width: '210px',
    height: '48px',
    background: '#FFFFFF !important',
    border: '1px solid #DFDFDF !important',
    borderRadius: '8px',
    textTransform: 'none !important',
    padding: '12px 76px 12px 76px',
    margin: '10px !important',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2 !important',
      border: '1px solid #6C2AD2 !important ',
    },
  },
  nextBtn: {
    margin: '10px !important',
    backgroundColor: '#965CF0 !important',
    fontFamily: 'Poppins !important',
    color: '#FFFFFF !important',
    fontSize: '16px',
    borderRadius: '8px !important',
    width: '210px',
    height: '48px',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    border: '1px solid #AF05FF !important',
    ' &:hover': {
      backgroundColor: '#965CF0 !important',
      border: '1px solid #AF05FF !important ',
    },
  },
  cancelBtn: {
    fontSize: '16px',
    fontFamily: 'Poppins !important',
    color: '#000 !important',
    width: '210px',
    height: '48px',
    background: '#FFFFFF !important',
    border: '1px solid #DFDFDF !important',
    borderRadius: '8px',
    textTransform: 'none !important',
    padding: '12px 76px 12px 76px',
    margin: '10px !important',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2 !important',
      border: '1px solid #6C2AD2 !important ',
    },
  },
  ModalcancelBtn: {
    fontSize: '16px',
    fontFamily: 'Poppins !important',
    color: '#000 !important',
    background: '#FFFFFF !important',
    border: '1px solid #DFDFDF !important',
    borderRadius: '8px',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    margin: '10px !important',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2 !important',
      border: '1px solid #6C2AD2 !important ',
    },
  },
  modalLable: {
    fontSize: '16px !important',
    color: '#000 !important',
    fontFamily: 'Poppins !important',
    fontWeight: '500px !important',
  },
  ModalnextBtn: {
    margin: '10px !important',
    backgroundColor: '#965CF0 !important',
    fontFamily: 'Poppins !important',
    color: '#FFFFFF !important',
    fontSize: '14px',
    borderRadius: '8px !important',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    border: '1px solid #AF05FF !important',
    ' &:hover': {
      backgroundColor: '#965CF0 !important',
      border: '1px solid #AF05FF !important ',
    },
  },
  inputLabel: {
    fontFamily: 'Poppins !important',
    marginTop: '35px',
    marginLeft: '20px',
  },
}));
